angular.module('cimerFrontEndApp').service('TagService', ['$q', '$http', 'ApiUrl',
    function ($q, $http, ApiUrl) {
        'use strict';
        var _apiUrl = ApiUrl.url('/Tag/');

        return {

            getDocumentsByTag: function (tag) {
                return $http.get(_apiUrl + 'GetDocumentsByTag/' + tag);
            },

            saveDocumentOrder: function (DocumentList, TagId) {
                var currentDocsAndTags =
                    {
                        DocumentList: DocumentList,
                        TagId: TagId
                    };
                return $http.post(_apiUrl + 'SaveDocumentOrder', currentDocsAndTags);
            }
        };
    }]);